import { useQuery } from '@tanstack/react-query';
import { fetchProductNames } from '../services/productNames';
import { dealerKeys } from './useDealersQuery';

const NO_NAMES: Map<string, string> = new Map();

export function useProductNames(enabled: boolean): Map<string, string> {
    const { data } = useQuery({
        queryKey: dealerKeys.productNames(),
        queryFn: fetchProductNames,
        enabled,
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000,
    });
    return data ?? NO_NAMES;
}
